import { type Properties } from 'posthog-js';
import { useContext, useMemo } from 'react';

import {
  type PostHogProxy,
  PostHogContext,
  wrapPostHog,
} from '../contexts/posthog-context';

export function usePostHog(properties?: Properties): PostHogProxy {
  const { posthog } = useContext(PostHogContext);
  return useMemo(() => wrapPostHog(posthog, properties), [posthog, properties]);
}
